import { render } from "./uni_map.vue?vue&type=template&id=5e8397b6"
import script from "./uni_map.vue?vue&type=script&lang=js"
export * from "./uni_map.vue?vue&type=script&lang=js"

import "./uni_map.vue?vue&type=style&index=0&id=5e8397b6&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__